<template>
    <div>
        <vue-query-builder
            v-model="queryObject"
            :rules="rules"
            :maxDepth="2"
            :labels="labels"
        >
            <template v-slot:default="slotProps">
                <query-builder-group
                    v-bind="slotProps"
                    :query.sync="queryObject"
                />
            </template>
        </vue-query-builder>
    </div>
</template>

<script>
import VueQueryBuilder from "vue-query-builder";
import QueryBuilderGroup from "./QueryBuilderGroup";

export default {
    components: {
        VueQueryBuilder,
        QueryBuilderGroup,
    },

    props: {
        query: Object,
        rules: Array,
    },

    created() {
        this.queryObject = JSON.parse(JSON.stringify(this.query));
    },

    watch: {
        queryObject() {
            this.$emit("input", this.queryObject);
        },
    },

    data() {
        return {
            queryObject: {
                logicalOperator: "all",
                children: [],
            },

            labels: {
                matchType: "Operador",
                field: "Campo",
                matchTypes: [
                    { id: "all", label: "E" },
                    { id: "any", label: "Ou" },
                ],
                addRule: "Adicionar regra",
                removeRule: "&times;",
                addGroup: "Adicionar grupo",
                removeGroup: "&times;",
                textInputPlaceholder: "Valor",
            },
        };
    },

    methods: {
        //
    },
};
</script>

<style>
.vqb-group-body .vqb-children {
    margin-left: 0px !important;
}

.vqb-group .vqb-group-heading {
    padding-left: 8px;
}
.vqb-group .vqb-group-body {
    padding-left: 8px;
}

.vue-query-builder {
    padding: 5px;
}

.vue-query-builder .close {
    height: 18px !important;
    width: 20px !important;
    padding: 0px !important;
    padding-top: 0px !important;
    margin: 0px !important;
    margin-top: 0px !important;
    line-height: initial !important;
    color: #de3b30 !important;
    float: right;
}

.vqb-group-heading .close {
    margin-right: 15px !important;
}

.vue-query-builder .children {
    padding: 20px;
}
</style>
